'use strict';
define(['jquery'], function () {
    return {
        templateUrl: 'app/components/access-components/st-reached-limit/st-reached-limit.html',
        bindings: {
            title: '@',
            subtitle: '@',
            description: '@',
            errorType: '@',
            isWorkspaceOwner: '<',
            data: '<'
        },
        controller: ['$scope', '$state', '$stateParams', '$mdMedia',
            function ($scope, $state, $stateParams, $mdMedia) {
                $scope.cancel = $scope.$parent.cancel;
                $scope.goToChoosePlan = goToChoosePlan;
                $scope.$mdMedia = $mdMedia;

                function goToChoosePlan() {
                    $scope.$parent.cancel();
                    $state.go('upgrade.choose-plan');
                }
            }]
    };
});
